import { FileObjectType } from "@jsq/ds/core";
import { RequestedDocumentType } from "../../../graphql/supergraph.index";
import {
  DocumentsUploadedByInvitedUser,
  BaseDocumentType as BaseDocumentTypeEnum,
  DocumentStatus,
} from "../../../graphql/supergraphOperations";
import { DocumentFormProps } from "../DocumentCollector/types";
import { getDocumentCategoryInfo } from "../DocumentCollector/utils";

export const mapGuestDocumentsToFormProps = (
  documentTypes: Array<RequestedDocumentType>,
  documents: Array<DocumentsUploadedByInvitedUser>,
): DocumentFormProps[] => {
  return (
    documentTypes
      // WSeriesTaxForm shouldn't be shown it would be collected in the subscription document
      .filter((docType) => docType.baseType !== BaseDocumentTypeEnum.WSeriesTaxForm)
      // Filter out documents that are marked as uploaded but don't exist in the documents array
      .filter((docType) => {
        // If the document type is marked as uploaded, verify it exists in the documents array
        if (docType.status === DocumentStatus.Uploaded) {
          const exists = documents.some(
            (doc) =>
              doc && docType.baseType === doc.baseType && docType.subType === doc.subType,
          );
          // Only include it if it exists in the documents array
          return exists;
        }
        // Include all non-uploaded document types
        return true;
      })
      .map((docType) => {
        const matchingDocument = documents.find((doc) => {
          if (!doc) return false;
          return doc.baseType === docType.baseType && doc.subType === docType.subType;
        });
        const documentCategory = getDocumentCategoryInfo(docType.baseType, docType.subType);

        return {
          id: matchingDocument?.id,
          baseType: docType.baseType,
          subType: docType.subType || null,
          file: matchingDocument?.name
            ? ({
                status: "accepted",
                file: {
                  name: matchingDocument?.name,
                },
                uuid: `${matchingDocument?.name}`,
                url: `${matchingDocument.name}`,
              } as FileObjectType)
            : null,
          title: documentCategory.title,
          description: documentCategory.description,
        };
      })
  );
};

const findMissingGuestDocuments = (
  documentTypes: Array<RequestedDocumentType>,
  documents: Array<DocumentsUploadedByInvitedUser>,
) => {
  // Find document types that don't have corresponding documents
  return (
    documentTypes
      // WSeriesTaxForm shouldn't be shown it would be collected in the subscription document
      .filter((docType) => docType.baseType !== BaseDocumentTypeEnum.WSeriesTaxForm)
      // Filter out documents that are marked as uploaded but don't exist in the documents array
      .filter((docType) => {
        // If the document type is marked as uploaded, verify it exists in the documents array
        if (docType.status === DocumentStatus.Uploaded) {
          const exists = documents.some(
            (doc) =>
              doc && docType.baseType === doc.baseType && docType.subType === doc.subType,
          );
          // Only include it if it exists in the documents array
          return exists;
        }
        // Include all non-uploaded document types
        return true;
      })
      .filter((docType) => {
        const hasMatchingDocument = documents.some((doc) => {
          if (!doc) return false;
          return docType.baseType === doc.baseType && docType.subType === doc.subType;
        });

        return !hasMatchingDocument;
      })
  );
};

export const hasMissingGuestDocuments = (
  documentTypes: Array<RequestedDocumentType>,
  documents: Array<DocumentsUploadedByInvitedUser>,
): boolean => {
  const missingDocuments = findMissingGuestDocuments(documentTypes, documents);
  return missingDocuments.length > 0;
};
